import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { Card, CardActions, CardContent, Skeleton, } from '@mui/material';
import { SimTariffBenefits } from 'console/sim/shared/compare-tariff/benefits';
import { SimChooseButton, TariffHeader, } from 'console/sim/shared/compare-tariff/tariff-header';
export const TariffCard = memo(function TariffCard(props) {
    const { tariff, isCurrent, isUpgrade, onChoose, loading } = props;
    const { id, title } = tariff;
    return (_jsx(_Fragment, { children: _jsxs(Card, { variant: "outlined", sx: {
                height: '100%',
                minHeight: 584,
                borderRadius: '4px',
                '& .MuiPaper-root': {
                    display: 'flex',
                    flexFlow: 'column nowrap',
                },
                '& .MuiCardActions-root': {
                    justifyContent: 'center',
                },
            }, children: [loading ? (_jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 50 })) : (_jsx(TariffHeader, { variant: "filled", id: id, title: title, typographyProps: { variant: 'subtitle1', sx: { fontSize: '160%' } }, boxProps: {
                        ml: 3,
                        width: '100%',
                        boxSizing: 'border-box',
                    } })), _jsx(CardContent, { sx: { flexGrow: 1, p: 0, px: 0.5 }, children: _jsx(SimTariffBenefits, { tariff: tariff, loading: loading }) }), _jsx(CardActions, { children: _jsx(SimChooseButton, { id: id, title: title, ...props }) })] }) }));
});
